import { useEffect, useRef } from 'react';

export function useClickAway(cb) {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (event) => {
      const element = ref.current;
      if (
        element
        && !element.contains(event.target)
        && event.target.ariaLabel !== 'clickable-choice'
      ) {
        cb();
      }
    };

    document.addEventListener('mousedown', handler, true, { passive: true });
    document.addEventListener('touchstart', handler, true, { passive: true });

    return () => {
      document.removeEventListener('mousedown', handler, true, { passive: true });
      document.removeEventListener('touchstart', handler, true, { passive: true });
    };
  }, [cb]);

  return ref;
}
